// extracted by mini-css-extract-plugin
module.exports = {"wrap-dots":"Dots_wrap-dots__3TtAE","dot":"Dots_dot__3ZnfA","dotTicket":"Dots_dotTicket__3VzkB"};